if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          slider: {}
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.initSlider();
        if (!this.elements.thumbnails) return;

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
      }

      isTouchDevice() {
        return (('ontouchstart' in window) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0));
      }

      initSlider() {

        const gallery = this;
        new Swiper(this.elements.viewer, {
          slidesPerView: 1,
          observer: true,
          resizeObserver: true,
          centerInsufficientSlides: true,
          preventClicks: true,
          preventClicksPropagation: true,
          slideToClickedSlide: false,
          navigation: {
            nextEl: 'media-gallery .button-next',
            prevEl: 'media-gallery .button-prev',
          },
          on: {
            init: function(swiper){
              swiper.navigation.nextEl.classList.remove('visually-hidden');
              swiper.navigation.prevEl.classList.remove('visually-hidden');
              gallery.elements.slider = swiper;
            },
            slideChange: function (swiper) {
              gallery.elements.slider = swiper;
              const activeSlide = swiper.slides[swiper.activeIndex];
              gallery.onSlideChanged(activeSlide);
            },
            resize: function(swiper){
              swiper.navigation.update();
            }
          },
          breakpoints: {
            750: {
              noSwiping: this.isTouchDevice() === false ? true : false,
              noSwipingClass: "swiper-slide"
            }
          },
          pagination: {
            el: 'media-gallery .swiper-pagination',
            type: 'bullets',
            clickable: true
          }
        });
      }

      onSlideChanged(activeSlide) {
        if(this.elements.thumbnails){
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${activeSlide.dataset.mediaId}"]`,
          );
          this.setActiveThumbnail(thumbnail);
        }
        const activeSlideCounter = this.elements.viewer.querySelector('.slider-counter--current');
        activeSlideCounter && (activeSlideCounter.innerText = this.elements.slider?.activeIndex + 1);
      }

      setActiveMedia(mediaId) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        const newActiveIndex = [...this.elements.slider?.slides].indexOf(activeMedia);
        this.elements.slider?.slideTo(newActiveIndex);

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft - (this.mql.matches === false ? 30 : 0)});
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    },
  );
}
